import React, { useState } from "react";

function RequestService() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const emailValid = /[^@\s]+@[^@\s]+\.[^@\s]+/.test(email);
  const messageValid = message.trim().length >= 10;
  const canSubmit = emailValid && messageValid;

  const handleSubmit = async (e) => {
  e.preventDefault();
  setError(null);
  setSuccess(false);

  // Client-side validation for file
  if (file) {
      const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    if (!validTypes.includes(file.type)) {
      setError("Only JPG and PNG images are allowed.");
      return;
    }
    if (file.size > 5 * 1024 * 1024) {
      setError("File too large. Maximum size is 5 MB.");
      return;
      }
  }

  const formData = new FormData();
  formData.append("email", email);
  formData.append("message", message);
  if (file) {
    formData.append("attachment", file);
  }

  try {
    const res = await fetch("/api/mail", {
    method: "POST",
    body: formData,
  });

  const data = await res.json();
  if (data.ok) {
    setSuccess(true);
    setEmail("");
    setMessage("");
    setFile(null);
  } else {
    setError(data.error || "Mailer error");
  }
  } catch (err) {
    console.error("Error submitting form:", err);
    setError("Failed to send request.");
  }
  };

  return (
    <section className="request container">
    <h2>Request Service</h2>
    <p className="sub">Tell us what you need—we'll route it to our dispatch team immediately.</p>
    <p className="sub">Please include your <b>name, phone number, facility name, room number or any other details</b> to help us resolve this issue quickly.</p>

    <form className="form" onSubmit={handleSubmit} noValidate>
      <div className="form-field">
      <label htmlFor="email">Your Email</label>
      <input
        id="email"
        name="email"
        type="email"
        inputMode="email"
        placeholder="you@company.com"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        aria-invalid={!emailValid && email.length > 0}
        />
        {!emailValid && email.length > 0 && (
        <div className="field-error">Please enter a valid email address.</div>
        )}
      </div>

      <div className="form-field">
      <label htmlFor="message">How can we help?</label>
      <textarea
        id="message"
        name="message"
        placeholder="Describe the issue, location, and any access details..."
        rows={6}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        required
        aria-invalid={!messageValid && message.length > 0}
        />
        {!messageValid && message.length > 0 && (
        <div className="field-error">Please provide at least 10 characters.</div>
        )}
      </div>

    <div className="form-field">
    <label>Attachment (optional):</label>
    <input
      type="file"
      accept="image/*"
      onChange={(e) => setFile(e.target.files[0])}
    />
    </div>
    <button className="btn-primary" type="submit" disabled={!canSubmit}>
      Send Request
    </button>
    {error && <p style={{ color: "red" }}>{error}</p>}
    {success && <p style={{ color: "green" }}>Request sent successfully!</p>}
    </form>
    
    <div className="contact-note">
    </div>
    </section>
  );
}

export default RequestService;